
import { toast as sonnerToast, ToasterProps } from "sonner";

// Define a more specific type for our toast options that includes action
interface EnhancedToastOptions extends ToasterProps {
  action?: {
    label: string;
    onClick: () => void;
  };
  description?: string;
}

// Improved toast wrapper with consistent durations and enhanced styling
const toast = {
  success: (message: string, options?: EnhancedToastOptions) => {
    return sonnerToast.success(message, { 
      duration: 2000, // 2 seconds default
      position: "top-right",
      ...options 
    });
  },
  error: (message: string, options?: EnhancedToastOptions) => {
    return sonnerToast.error(message, { 
      duration: 3000, // 3 seconds default for errors (more time to read)
      position: "top-right",
      ...options 
    });
  },
  info: (message: string, options?: EnhancedToastOptions) => {
    return sonnerToast.info(message, { 
      duration: 2000, // 2 seconds default
      position: "top-right",
      ...options 
    });
  },
  warning: (message: string, options?: EnhancedToastOptions) => {
    return sonnerToast.warning(message, { 
      duration: 2500, // 2.5 seconds default for warnings
      position: "top-right",
      ...options 
    });
  },
  // Add custom loading toast with auto-dismiss
  loading: (message: string, options?: EnhancedToastOptions) => {
    return sonnerToast.loading(message, {
      duration: Infinity, // Won't dismiss automatically
      position: "top-right",
      ...options
    });
  },
  // Improved dismissible custom toast for device errors
  device: (message: string, options?: EnhancedToastOptions) => {
    return sonnerToast.error(message, {
      duration: 5000, // Reasonable duration for device errors
      position: "top-right",
      className: "device-error-toast", // Custom class for styling
      description: options?.description || "Try refreshing the page if this persists",
      ...options
    });
  },
  // Add promise support
  promise: sonnerToast.promise,
  // Add dismiss method
  dismiss: (toastId?: string) => sonnerToast.dismiss(toastId)
};

export { toast };
